"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unwrap = unwrap;

function unwrap(val) {
  if (val === undefined || val === null) {
    throw new Error('Non-nullable object must have a value');
  }

  return val;
}